import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactNode } from 'react';
import type { RelatedLinksCategory } from '../RelatedLinks';

export interface FooterLink {
  label: string;
  onClick?: MouseEventHandler;
  link?: LocationDescriptor;
}

export interface FooterCategory {
  title: string;
  links: FooterLink[];
  children?: ReactNode;
}

export interface FooterRow {
  links: FooterLink[];
}

export interface FooterData {
  categories: FooterCategory[];
  rows: FooterRow[];
  internalLinks?: RelatedLinksCategory[];
}

export interface FooterProps extends FooterData {}
